import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () =>
      import(/* webpackChunkName: "Home" */ "../Views/Home"),
    meta: { hideNavigation: true, },
  },
  // {
  //   path: "/BSA",
  //   name: "BSA Portal",
  //   component: () =>
  //     import(/* webpackChunkName: "BSA_Portal" */ "../Portals/BSA/BSA_Portal"),
  // },
  // {
  //   path: "/NBL1",
  //   name: "NBL Portal",
  //   component: () =>
  //     import(/* webpackChunkName: "NBL1_Portal" */ "../Portals/NBL1/NBL1_Portal"),
  //   props: true
  // },
  // {
  //   path: "/Login",
  //   name: "Login",
  //   component: () =>
  //     import(/* webpackChunkName: "Login" */ "../common/Login"),
  // },
  // {
  //   path: "/Register",
  //   name: "Register",
  //   component: () =>
  //     import(/* webpackChunkName: "Register" */ "../common/Register"),
  // },
  // {
  //   path: "/Reset",
  //   name: "Reset",
  //   component: () =>
  //     import(/* webpackChunkName: "Login" */ "../common/Reset"),
  // },
];


const router = new VueRouter({
  mode: "history",
  // eslint-disable-next-line no-undef
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const loggedIn = !!localStorage.getItem("user");
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!loggedIn) {
      Vue.$toast.error(`You must be logged in to access this menu item !`, {
        timeout: 2000,
      });
      next("/Login");
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;